'use strict';

/*
	Disable TEL links ('<a href="tel:..." ') in the case of DESKTOP viewport
*/
document.addEventListener('DOMContentLoaded', () => {

	const mlQuery = llbstyle.mediaQueryCheck.query('ml');

	const mlCheck = llbstyle.utilities.batch(() => {

		const isBreakpointMatching = mlQuery.matches;

		$('a[href^="tel:"]').each(function () {
			if (isBreakpointMatching) {
				//DESKTOP
				if (this.hasAttribute("style") == false) {
					this.setAttribute("style", "");
				}
				this.style.setProperty("pointer-events", "none");
			} else {
				//MOBILE
				if (this.hasAttribute("style")) {
					this.style.removeProperty("pointer-events");
				}
			}
		});
	}, 200);

	llbstyle.mediaQueryCheck.query('ml').addEventListener('change', mlCheck);

	mlCheck();

}, { once: true } );
